import React from 'react';
import DrawingToolbar from '../../Toolbars/drawing-toolbar';
import PopUpHelper from "../../Calculations/popUpHelper.component";

export default class BackgroundImageComponent extends React.Component {
  render() {
    const {
      lang,
      content,
    } = this.props;

    const css = {
      card: {
        margin: "10px",
        height: "100%",
      },
      leftAlign: {
        textAlign: "left"
      }
    };

    return (
      <div style={css.cardWrapper}>
        <div style={css.card}>
          {/* <DocumentCardTitle title="DETAILS" /> */}
          <div style={css.leftAlign}>{content[lang].background}
            <div className="questionMark" style={{ display: "inline-block", paddingLeft: "5px" }}>
              <PopUpHelper text={content[lang].pdfDisclaimer} />
            </div>
          </div>
          <div style={css.leftAlign}>
            <DrawingToolbar
              lang={lang}
              content={content}
            />
          </div>
          <div> &nbsp; </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/LeftMenu/BackgroundImage/background-image.component.js